<template>
  <div >
      <v-card>
        <v-card-title style="background-color: rgb(21, 101, 192); color: white;">
          ข้อมูลการตั้งเบิก
        </v-card-title>

        <v-card-text>
          <br />
          <h3>เลขที่ตั้งเบิก : {{withdrawData.withdrawNo}} </h3>
          ระบบได้ทำบันทึกข้อมูลการตั้งเบิก {{withdrawData.trnCount}} รายการ
          <br />จากใบแจ้งหนี้ ตั้งแต่เวลา {{withdrawData.rankDate}}
          <br />ยอดรวม {{withdrawData.trnTotalDisplay}} บาท
          <br />ยอดตั้งเบิก {{withdrawData.trnGrandTotalDisplay}} บาท
           <br /><span class="green--text">เรียบร้อยแล้ว!!</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="close"
          >
            CLOSE
          </v-btn>
        </v-card-actions>
      </v-card>
  </div>
</template>

<script>
export default {
   name: 'popup',
   props: ["withdrawData"],
  methods: {
        close() {
           this.$emit("closeDialog");
        }
  }
   

}
</script>